import ApiClient from './ApiClient';

class NervenetEmbedTokenAPI extends ApiClient {
  constructor() {
    super('nervenet_embed_token', { accountScoped: true });
  }
}

export default new NervenetEmbedTokenAPI();
